
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  IFigure,
  IVideo,
  IVideoAsset,
  SanityDocumentSchema,
  ISanityDocuments,
} from '~/types/sanity-documents';
import ViewFigureDialog from '~/components/Sanity/ViewFigureDialog.vue';
import WatchVideoDialog from '~/components/Sanity/WatchVideoDialog.vue';

@Component({
  components: {
    WatchVideoDialog,
    ViewFigureDialog,
  },
})
export default class FilmMediaTabItem extends Vue {
  @Prop({ type: Number, default: 16 / 9 })
  readonly aspectRatio!: number;
  @Prop({ type: Number, default: 284 })
  readonly width!: number;
  @Prop(Object) readonly data!:
    | ISanityDocuments[SanityDocumentSchema.FIGURE]
    | ISanityDocuments[SanityDocumentSchema.VIDEO];

  schemas = SanityDocumentSchema;

  get height() {
    return this.aspectRatio
      ? Math.round(this.width * (1 / this.aspectRatio))
      : 0;
  }

  get imageUrl() {
    return !this.image
      ? ''
      : this.$sanityImage
          .urlFor(this.image)
          .width(this.width)
          .height(this.height)
          .fit('crop')
          .url();
  }

  get type() {
    return this.data?._type || undefined;
  }

  get id() {
    return this.data?._id || undefined;
  }

  get image() {
    return this.type === 'video' && (this.data as IVideo)?.poster
      ? (this.data as ISanityDocuments[SanityDocumentSchema.VIDEO])?.poster
      : (this.data as ISanityDocuments[SanityDocumentSchema.FIGURE])?.image;
  }

  get videoAsset() {
    if (this.type !== this.schemas.VIDEO) {
      return;
    }
    return this.$sanityLookup.getDocumentFromReference<
      ISanityDocuments[SanityDocumentSchema.MUX_ASSET]
    >({
      _ref: (this.data as ISanityDocuments[SanityDocumentSchema.VIDEO])?.video
        ?.asset?._ref,
    })?.data;
  }

  get slug() {
    return this.data?.slug;
  }
}
